export const environment = {
  production: true,
  apiBaseUrl: 'api/v1',
  appName: 'CIB Bank Admin',
  version: '1.0.0'
};